import React, { useState } from "react";
import { Button, Input, Textarea, Typography } from "@material-tailwind/react";

const ContactForm = () => {
  // État pour le formulaire
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    address: "",
    phone: "",
    brand: "",
    message: "",
  });

  const [statusMessage, setStatusMessage] = useState("Envoyer"); // Pour afficher le statut
  const [statusSubmitDisabled, setStatusSubmitDisabled] = useState(true); // Pour désactiver le bouton
  const [buttonColor, setbuttonColor] = useState("gray"); // Pour désactiver le bouton

  // Gestion des changements dans les champs
  const handleChange = (e) => {
    const { name, value } = e.target;
	setFormData((prev) => ({ ...prev, [name]: value }));
    checkFormContent();
  };
  
  //Check content and define Send button availability
  const checkFormContent = () => {
	setStatusSubmitDisabled(!(formData.lastName.length >1 && formData.email.length && formData.phone.length >8 && formData.message.length >1));
	setbuttonColor("gray");
	setStatusMessage("Envoyer");
	
  }
  // Gestion de la soumission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage("Envoi en cours...");
    setStatusSubmitDisabled(true);
    try {
      const response = await fetch("/api/contact-request", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatusMessage("Formulaire envoyé  !");
		setbuttonColor("green");
		setFormData({
			firstName: "",
			lastName: "",
			email: "",
			address: "",
			phone: "",
			brand: "",
			message: "",
		  })
      } else {
        const error = await response.json();
        setStatusMessage(`Erreur : ${error.message}`);
      }
    } catch (error) {
      setStatusMessage(`Erreur de connexion : ${error.message}`);
    }
  };
  return (
		<div className="px-8 py-4 mx-auto text-center">
			<Typography className="mb-4 font-normal !text-lg lg:mb-10 mx-auto max-w-3xl !text-gray-500">
			  Le formulaire ci-dessous me permettra de traiter votre demande au plus vite, que ce soit pour la programmation d'un rendez-vous ou pour une demande de renseignement.
			</Typography>
			<div className="w-full flex items-center justify-center">
				<form onSubmit={handleSubmit} className="flex flex-col gap-4 lg:max-w-sm text-left font-medium">
					<div className="grid grid-cols-2 gap-4">
						<div>
							<Typography variant="small" className="mb-1">Prénom</Typography>
							<Input color="gray" size="lg" placeholder="Prénom" name="firstName" className="border-t-gray-500 focus:border-t-gray-700" value={formData.firstName} onChange={handleChange} containerProps={{ className:"!min-w-full" , }} labelProps={{ className:"hidden" , }}/>
						</div>
						<div>
							<Typography variant="small" className="mb-1">Nom</Typography>
							<Input color="gray" size="lg" placeholder="Nom" name="lastName" className="border-t-gray-500 focus:border-t-gray-700" value={formData.lastName} onChange={handleChange} containerProps={{ className:"!min-w-full" , }} labelProps={{ className:"hidden" , }}/>
						</div>
					</div>
					<div>
						<Typography variant="small" className="mb-1">Email</Typography>
						<Input type="email" color="gray" size="lg" placeholder="name@gmail.com" name="email" className="border-t-gray-500 focus:border-t-gray-700" value={formData.email} onChange={handleChange} containerProps={{ className:"!min-w-full" , }} labelProps={{ className:"hidden" , }}/>
					</div>
					<div>
						<Typography variant="small" className="mb-1">Téléphone</Typography>
						<Input color="gray" size="lg" placeholder="06 00 00 00 00" name="phone" className="border-t-gray-500 focus:border-t-gray-700" value={formData.phone} onChange={handleChange} containerProps={{ className:"!min-w-full" , }} labelProps={{ className:"hidden" , }}/>
					</div>
					<div>
						<Typography variant="small" className="mb-1">Marque et modèle du piano</Typography>
						<Input color="gray" size="lg" placeholder="Yamaha XXXXX" name="brand" className="border-t-gray-500 focus:border-t-gray-700" value={formData.brand} onChange={handleChange} containerProps={{ className:"!min-w-full" , }} labelProps={{ className:"hidden" , }}/>
					</div>
					<div>
						<Typography variant="small" className="mb-1">Adresse (où est situé le piano)</Typography>
						<Input color="gray" size="lg" placeholder="123 rue des peupliers 00000 Ville" name="address" className="border-t-gray-500 focus:border-t-gray-700" value={formData.address} onChange={handleChange} containerProps={{ className:"!min-w-full" , }} labelProps={{ className:"hidden" , }}/>
					</div>
					<div>
						<Typography variant="small" className="mb-1">Votre message</Typography>
						<Textarea rows={6} color="gray" placeholder="Message" name="message" className="border-t-gray-500 focus:border-t-gray-700" value={formData.message} onChange={handleChange} containerProps={{ className:"!min-w-full" , }} labelProps={{ className:"hidden" , }}/>
					</div>
					<Button className="w-full" disabled={statusSubmitDisabled} color={buttonColor} type="submit">{statusMessage}</Button>
				</form>
			</div>
		</div>
  );
}

export default ContactForm;